import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useCatalogContext } from 'modules/catalog/catalogSelector';
import { CatalogFieldDetails, FieldType } from 'modules/domains';

const createCatalogFieldDetails = (
  catalogFieldDetails: option.Option<CatalogFieldDetails> = option.none,
): CatalogFieldDetails =>
  pipe(
    catalogFieldDetails,
    option.getOrElse(() => ({ fieldType: FieldType.STRING }) as CatalogFieldDetails),
  );

export const useGetCatalogFieldDetails = () => {
  const { catalogFieldDetails } = useCatalogContext();
  return createCatalogFieldDetails(catalogFieldDetails);
};
